// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"greater-than"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 4L19 12L5 20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GreaterThanIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'greater-than',
    ref,
    icon: element,
  },
));

GreaterThanIcon.displayName = 'GreaterThanIcon';

export default GreaterThanIcon;
